module.exports = __webpack_public_path__ + "static/img/Savelio-Tamale.b450bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savelio-Tamale.jpg
// module id = 00g/
// module chunks = 0